/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  InitiateRefundResponse,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    InitiateRefundResponseFromJSON,
    InitiateRefundResponseToJSON,
} from '../models';

export interface RefundSoftpayPaymentRequest {
    locationId: number;
    softpayTerminalId: string;
    paymentReference: string;
}

/**
 * 
 */
export class RefundSoftpayPaymentControllerApi extends runtime.BaseAPI {

    /**
     */
    async refundSoftpayPaymentRaw(requestParameters: RefundSoftpayPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiateRefundResponse>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling refundSoftpayPayment.');
        }

        if (requestParameters.softpayTerminalId === null || requestParameters.softpayTerminalId === undefined) {
            throw new runtime.RequiredError('softpayTerminalId','Required parameter requestParameters.softpayTerminalId was null or undefined when calling refundSoftpayPayment.');
        }

        if (requestParameters.paymentReference === null || requestParameters.paymentReference === undefined) {
            throw new runtime.RequiredError('paymentReference','Required parameter requestParameters.paymentReference was null or undefined when calling refundSoftpayPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/locations/{locationId}/softpay-terminals/{softpayTerminalId}/payments/{paymentReference}/refund`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"softpayTerminalId"}}`, encodeURIComponent(String(requestParameters.softpayTerminalId))).replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters.paymentReference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiateRefundResponseFromJSON(jsonValue));
    }

    /**
     */
    async refundSoftpayPayment(requestParameters: RefundSoftpayPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiateRefundResponse> {
        const response = await this.refundSoftpayPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
